import type { ReactNode } from "react";

interface Props {
  headingId: string;
  group: string;
  title: string;
  description: string;
  children?: ReactNode;
}

export function PageSectionHeader({ headingId, group, title, description, children }: Props) {
  return (
    <header className="flex flex-wrap items-end justify-between gap-x-6 gap-y-3 pb-4 mb-4 border-b border-rs-jet">
      <div className="flex flex-col gap-1 min-w-0">
        <p className="m-0 text-[11px] font-semibold uppercase tracking-[0.1em] text-rs-green">{group}</p>
        <h2 id={headingId} className="m-0 text-2xl font-semibold tracking-[-0.01em] max-[700px]:text-[21px]">
          {title}
        </h2>
        <p className="m-0 mt-0.5 max-w-[66ch] text-sm text-rs-light-gray">{description}</p>
      </div>
      {children && <div className="flex flex-wrap items-center gap-1.5">{children}</div>}
    </header>
  );
}
